import React from 'react';
import { Box, FinalRate, FinalRateProps, FlexDirection, JustifyContent, Typography } from '@drone-js/core';
import { Token } from '@agoda/react-handyman/lib/utils/priceFormatter/types';
import { AlignItems } from '@drone-js/core/src/types/Types';

interface OwnProps {
    formattedAmountTokens: Token[];
    formattedCorAmount?: string;
    prefix?: string;
    priceDirection?: FlexDirection;
    priceJustifyContent?: JustifyContent;
    finalPriceSize?: FinalRateProps['size'];
    priceAlignItems?: AlignItems;
}

export const PriceWithPrefix: React.FC<OwnProps> = ({
    formattedAmountTokens,
    formattedCorAmount,
    prefix,
    priceDirection = 'row',
    priceJustifyContent = 'flex-start',
    finalPriceSize = 'm',
    priceAlignItems = 'baseline',
}) => {
    return (
        <Box data-testid="activities-price" alignItems={priceAlignItems} display="flex" flexDirection={priceDirection} flexWrap="wrap" justifyContent={priceJustifyContent}>
            {formattedCorAmount && (
                <Typography textColor="base.subtle" textDecoration="line-through" variant="caption-default" data-testid="activities-original-price" me="4">
                    {formattedCorAmount}
                </Typography>
            )}
            {!formattedCorAmount && prefix && (
                <Typography textColor="base.default" variant="caption-default" data-testid="activities-price-prefix" me="4">
                    {prefix}
                </Typography>
            )}
            {/* Filter out type='literal' which is excessive space */}
            <FinalRate data-testid="activities-final-price" price={formattedAmountTokens.filter((token) => token.type !== 'literal')} size={finalPriceSize} />
        </Box>
    );
};
PriceWithPrefix.displayName = 'PriceWithPrefix';
